import RECORDING_STATUS from './RECORDING_STATUS';

export default {
  ACTIVE: new Set([RECORDING_STATUS.RECORDING]),
  RECORDED: new Set(Object.values(RECORDING_STATUS).filter((status) => status !== RECORDING_STATUS.RECORDING)),
  UPLOAD_PENDING: new Set([RECORDING_STATUS.RECORDED, RECORDING_STATUS.UPLOAD_FAILED]),
  UPLOAD_REQUIRED: new Set([RECORDING_STATUS.UPLOADING, RECORDING_STATUS.RECORDED, RECORDING_STATUS.UPLOAD_FAILED]),
  UPLOAD_IN_PROGRESS: new Set([RECORDING_STATUS.UPLOADING]),
  UPLOADING: new Set([RECORDING_STATUS.UPLOADING, RECORDING_STATUS.UPLOADED, RECORDING_STATUS.STITCHED]),
  UPLOADED: new Set([RECORDING_STATUS.UPLOADED, RECORDING_STATUS.STITCHED]),
  DELETED: new Set([RECORDING_STATUS.STITCHED]),
};
